export default __webpack_public_path__ + "static/media/hero-image-converted.9c1f535a.png";